
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"vuesax/twotone/rotate-right","xmlns":"http://www.w3.org/2000/svg","width":"20","height":"20","viewBox":"0 0 20 20"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#fff"}},[_c('path',{attrs:{"d":"M10 18.955a7.768 7.768 0 01-5.545-2.309 7.921 7.921 0 010-11.154A7.771 7.771 0 0110 3.184a8.86 8.86 0 012.584.386.628.628 0 01.425.781.624.624 0 01-.777.422A7.635 7.635 0 0010 4.434a6.63 6.63 0 106.593 6.635 6.645 6.645 0 00-1.11-3.685.629.629 0 01.173-.87.622.622 0 01.866.174 7.919 7.919 0 01-.976 9.954A7.771 7.771 0 0110 18.955z"}}),_c('path',{attrs:{"data-name":"Vector","d":"M13.449 5.079a.626.626 0 01-.474-.216l-2.426-2.778a.627.627 0 01.065-.889.627.627 0 01.885.061l2.419 2.782a.627.627 0 01-.469 1.04z"}}),_c('path',{attrs:{"data-name":"Vector","d":"M10.626 7.118a.627.627 0 01-.507-.258.627.627 0 01.137-.877l2.819-2.057a.627.627 0 01.873.137.627.627 0 01-.137.877l-2.816 2.057a.625.625 0 01-.369.121z"}})])])
          )
        }
      }
    